import { Link } from "react-router-dom";

export default function Logo({ size = "h-10" }) {
  return (
    <Link data-testid="logo-link-home" to="/" className="flex items-center gap-3 group">
      <img
        src={`${process.env.PUBLIC_URL}/mark.png`}
        alt="Oxygen Gym flame mark"
        className={`${size} w-auto rounded-lg ring-1 ring-gold/40 group-hover:ring-gold transition-all duration-300`}
      />
      <span className="hidden sm:block font-display uppercase tracking-wide text-lg leading-none">
        Oxygen <span className="text-gold-gradient">Gym</span>
        <span className="block font-mono text-[9px] tracking-[0.3em] text-white/50 mt-1">UNLEASH YOUR POWER</span>
      </span>
    </Link>
  );
}
